import { notifications } from "../../constants/actionTypes";

const INITIAL_STATE = {
  notificationsList: {},
  readStatusData: {},
  notificationError: "",
};

const notificationsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case notifications.SUCCESS_NOTIFICATIONS_LIST:
      return {
        ...state,
        notificationsList: { ...action?.payload?.data },
      };
    case notifications.ERROR_NOTIFICATIONS_LIST:
      return {
        ...state,
        notificationError: action?.payload,
      };
    case notifications.SUCCESS_READ_STATUS:
    case notifications.ERROR_READ_STATUS:
      return {
        ...state,
        readStatusData: action?.payload,
      };
    case notifications.SET_READ_STATUS:
      const updateNotificationsList = {
        ...state?.notificationsList,
        results: state?.notificationsList?.results?.map((notification) => {
          if (notification?.id === action?.payload?.id) {
            return { ...notification, read_status: true };
          } else {
            return notification;
          }
        }),
      };
      return {
        ...state,
        notificationsList: { ...updateNotificationsList },
      };
    default:
      return state;
  }
};

export default notificationsReducer;
